import type { MultiStepScenarioCollection } from '@ms/yammer-telemetry-support';

import { createNamespacedStorageValue } from './namespacedStorageValue';

const multiStepScenarioPerformance = createNamespacedStorageValue<MultiStepScenarioCollection>(
  'MultiStepScenarioPerformance',
  () => ({})
);

export const getMultiStepScenarioPerformanceCollection = (): MultiStepScenarioCollection =>
  multiStepScenarioPerformance.get();
export const setMultiStepScenarioPerformanceCollection = (
  multiStepScenarioCollection: MultiStepScenarioCollection
): void => {
  multiStepScenarioPerformance.set(multiStepScenarioCollection);
};
export const removeMultiStepScenarioPerformanceCollection = (): void => {
  multiStepScenarioPerformance.remove();
};
